import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import React from "react";
interface UnifiedWavesListLoaderProps {
  readonly isFetching?: boolean | undefined;
  readonly isFetchingNextPage: boolean;
}
export const UnifiedWavesListLoader: React.FC<UnifiedWavesListLoaderProps> = t0 => {
  const $ = _c(1);
  const {
    isFetching: t1,
    isFetchingNextPage
  } = t0;
  const isFetching = t1 === undefined ? false : t1;
  if (!isFetching && !isFetchingNextPage) {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <motion.div data-testid="loader" className="tw-flex tw-justify-center tw-items-center tw-gap-1 tw-py-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.2
    }}><div className="tw-w-1.5 tw-h-1.5 tw-bg-iron-400 tw-rounded-full tw-animate-pulse" /><div className="tw-w-1.5 tw-h-1.5 tw-bg-iron-400 tw-rounded-full tw-animate-pulse tw-animation-delay-200" /><div className="tw-w-1.5 tw-h-1.5 tw-bg-iron-400 tw-rounded-full tw-animate-pulse tw-animation-delay-400" /></motion.div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  return t2;
};